import script from "./dpc-calendar-vertical-error.vue?vue&type=script&setup=true&lang=js"
export * from "./dpc-calendar-vertical-error.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__